import { useApiClient } from '@m43/core';
import { useEffect, useState } from 'react';
import { CadNextRelatedDataLocationQuery, RelatedDataResource } from '@mark43/cad-api';
import { useQuery } from '@tanstack/react-query';
import { GeoPointLocation } from '../../esri/types';
import { buildRelatedDataLocationQuery } from '../components/helpers';
import { useEnabledFeatures } from '../../common/hooks/enabled-features/use-enabled-features';

export const LOCATION_RELATED_DATA_CACHE_KEY = 'location-related-data';

export function useLocationRelatedData(geoPointLocation?: GeoPointLocation) {
    const { enhancedRelatedData } = useEnabledFeatures();

    const [
        relatedDataLocationQuery,
        setRelatedDataLocationQuery,
    ] = useState<CadNextRelatedDataLocationQuery>();

    useEffect(() => {
        if (geoPointLocation) {
            const relatedDataLocationQuery = buildRelatedDataLocationQuery(geoPointLocation);
            setRelatedDataLocationQuery(relatedDataLocationQuery);
        } else {
            setRelatedDataLocationQuery(undefined);
        }
    }, [geoPointLocation]);

    const apiClient = useApiClient();

    const locationRelatedDataQuery = useQuery(
        [LOCATION_RELATED_DATA_CACHE_KEY, relatedDataLocationQuery],
        async () => {
            const response = await apiClient.request<RelatedDataResource.GetRelatedDataByQuery>({
                method: 'POST',
                url: `related_data/`,
                data: {
                    cadNextRelatedDataLocationQuery: relatedDataLocationQuery,
                    limitSearchResultSize: true,
                    personQueries: [],
                    phoneNumbers: [],
                    vehicleQueries: [],
                },
            });
            const relatedDataView = response.data.data;

            if (!relatedDataView) {
                throw Error('The relatedDataView is missing.');
            }

            return relatedDataView;
        },
        {
            enabled: enhancedRelatedData && relatedDataLocationQuery !== undefined,
        }
    );

    return locationRelatedDataQuery;
}
